import React from "react";

const Shimmer = ({ width, height = 14, radius = 8 }) => (
  <span className="fq-shimmer" style={{ width, height, borderRadius: radius }} />
);

const WIDTHS = ["72%", "58%", "84%", "64%", "76%", "52%", "80%", "60%"];

export const FaqRowSkeleton = ({ width = "70%" }) => (
  <li className="fq-row fq-row-skeleton" aria-hidden="true">
    <span className="fq-question">
      <Shimmer width={width} height={15} />
      <Shimmer width={28} height={28} radius={999} />
    </span>
  </li>
);

export const FaqsListSkeleton = ({ rows = 8 }) => (
  <ul className="fq-list" aria-hidden="true">
    {Array.from({ length: rows }).map((unused, index) => (
      <FaqRowSkeleton key={index} width={WIDTHS[index % WIDTHS.length]} />
    ))}
  </ul>
);

export default Shimmer;
